import { api } from '@/api';
import { useActionWithConfirmation } from '@/components/confirmationModals/useActionWithConfirmation';

export function useDeleteNumericQuantityWithConfirmation() {
  return useActionWithConfirmation({
    confirmedAction: async (id: string) =>
      await api.numericQuantitiesApi.deleteNumericQuantity({
        id: id,
      }),
  });
}
